export default [
  {
    path: '/summary/view',
    name: 'Summary View',
    component: () => import('@/views/summary/index.vue'),
    meta: {
      icon: 'icon-Summary',
      resourceCode: 'summary',
    },
  },
];
